const API_URL = window.location.hostname === 'localhost' 
  ? (process.env.REACT_APP_API_URL || "http://localhost:3173") 
  : window.location.origin;
const USER_INFO_KEY = 'userInfo';
const TOKEN_KEY = 'authToken';
const SELECTED_CLIENT_KEY = 'selectedClientId';

const LOCAL_DEV_USER = {
  id: Number(process.env.REACT_APP_LOCAL_DEV_USER_ID || 1),
  email: process.env.REACT_APP_LOCAL_DEV_EMAIL || "local-admin@salesbreaker.local",
  name: process.env.REACT_APP_LOCAL_DEV_NAME || "Local Admin",
  role: process.env.REACT_APP_LOCAL_DEV_ROLE || "admin",
  client_id: process.env.REACT_APP_LOCAL_DEV_CLIENT_ID || "local-dev-client"
};

const LOCAL_DEV_TOKEN = process.env.REACT_APP_LOCAL_DEV_AUTH_TOKEN || "";
const LOCAL_DEV_AUTH_ENABLED =
  window.location.hostname === "localhost" &&
  process.env.REACT_APP_ENABLE_LOCAL_DEV_AUTH !== "false";

const bootstrapLocalDevSession = () => {
  if (!LOCAL_DEV_AUTH_ENABLED) return;

  const hasToken = localStorage.getItem(TOKEN_KEY);
  const hasUser = localStorage.getItem(USER_INFO_KEY);

  if (!hasToken && LOCAL_DEV_TOKEN) {
    localStorage.setItem(TOKEN_KEY, LOCAL_DEV_TOKEN);
  }

  if (!hasUser) {
    localStorage.setItem(USER_INFO_KEY, JSON.stringify(LOCAL_DEV_USER));
  }

  if (!localStorage.getItem(SELECTED_CLIENT_KEY) && LOCAL_DEV_USER.client_id) {
    localStorage.setItem(SELECTED_CLIENT_KEY, LOCAL_DEV_USER.client_id);
  }
};

bootstrapLocalDevSession();

/**
 * ログイン処理
 * @param {string} email
 * @param {string} password
 * @returns {Promise<object>} ユーザー情報
 */
export const login = async (email, password) => {
  const response = await fetch(`${API_URL}/api/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'ログインに失敗しました。');
  }

  const data = await response.json();
  if (data.token && data.id) {
    localStorage.setItem(TOKEN_KEY, data.token);
    // ユーザー情報からトークンを除いて保存
    const { token, ...userInfo } = data;
    localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
    return userInfo;
  } else {
    throw new Error('サーバーから無効なデータが返されました。');
  }
};

/**
 * ログアウト処理
 */
export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_INFO_KEY);
  sessionStorage.removeItem('salesbreaker:free-plan-survey:idempotency-key');
  sessionStorage.removeItem('salesbreaker:free-plan-survey:retry-payload');
};

/**
 * 認証トークンを取得
 * @returns {string|null}
 */
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

/**
 * ログイン中のユーザー情報を取得
 * @returns {object|null}
 */
export const getUser = () => {
  const user = localStorage.getItem(USER_INFO_KEY);
  return user ? JSON.parse(user) : null;
};

/**
 * APIリクエスト用のヘッダーを取得
 * @param {boolean} includeContentType - Content-Type: application/json を含めるかどうか (デフォルト: false)
 * @returns {object}
 */
export const getAuthHeader = (includeContentType = false) => { // 引数を追加
  const token = getToken();
  const headers = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  // Content-Type を必要に応じて追加
  if (includeContentType) {
    headers['Content-Type'] = 'application/json'; // Content-Type を追加
  }
  return headers;
};
